import React from "react";
import './RNFBox.style.scss';
import { useDataLayer } from "../../../Contexts/DataLayer.context";
import { getUserFromToken } from "../../../utils/functions.ts";

const RNFBox = ({ buttonList, selectedButtons, helpbutton = true }) => {

    const {
        updateActualShared,
    } = useDataLayer();

    const buttonClicked = async (inval) => {
        const exists = selectedButtons.includes(inval);
        const updatedArray = exists
            ? selectedButtons.filter(item => item !== inval) // Remove item
            : [...selectedButtons.filter(item => item !== ""), inval]; // Remove empty string before adding
        updateActualShared(updatedArray);

        const user = await getUserFromToken();
        if (!user) return;
        try {
            fetch('https://www.fbxchange.com/ReactPHP/loadData.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    method: 'setNewShare',
                    team: user.team,
                    user: user.scout,
                    data: JSON.stringify(updatedArray)
                }).toString()
            }).catch(error => console.error('Request failed:', error)); // Handle potential fetch error
        } catch (error) {
            console.error('Unexpected error:', error);
        }
    }

    const showHelp = (inval) => {
        alert("When FBX retrieves players from our database, it displays the count of Reports (R), Notes (N), and Files (F) associated with each player. This section allows you to customize the sources used for these counts by selecting or deselecting the options provided.");

    }

    return (
        <div className="d-flex gap-1 fs-7 align-items-center">
            {buttonList.map((item, index) => (
                <div key={index} onClick={() => buttonClicked(item)} className={`btn btn-sm fs-8 ${selectedButtons.includes(item) ? 'btn-success' : 'btn-light'}`}>{item}</div>))}
            {helpbutton && <div onClick={() => showHelp('RNF')} className="btn btn-sm btn-info ms-2 px-3">?</div>}
        </div>
    )
}

export default RNFBox;